import { CollectionPath } from '@typings/collections.enum';
import fire from '@store/firebase';
const firestore = fire.firestore();

export enum ItemHistoryType {
  USE_STATUS = 'use_status',
  USE_MYROOM = 'use_myroom',
  USE_PET = 'use_pet',
  USE_RANDOM_BOX = 'use_randomBox',
  USE_BAG_EXPAND = 'use_bagExpand',
  USE_BETTING = 'use_betting',
  USE_QUEST = 'use_quest',
  USE_USERGIFT = 'use_userGift',
  GIFT = 'gift',
  SELL = 'sell',
  DELETE = 'delete',
}

const itemHistoryTypeMap: Record<ItemHistoryType, string> = {
  [ItemHistoryType.USE_STATUS]: '스탯 보정',
  [ItemHistoryType.USE_MYROOM]: '마이룸 꾸미기',
  [ItemHistoryType.USE_PET]: '펫 아이템 사용',
  [ItemHistoryType.USE_RANDOM_BOX]: '랜덤박스 오픈',
  [ItemHistoryType.USE_BAG_EXPAND]: '가방 확장',
  [ItemHistoryType.USE_BETTING]: '베팅 주제 생성',
  [ItemHistoryType.USE_QUEST]: '퀘스트 생성',
  [ItemHistoryType.USE_USERGIFT]: '아이템 만들기',
  [ItemHistoryType.GIFT]: '선물',
  [ItemHistoryType.SELL]: '판매',
  [ItemHistoryType.DELETE]: '삭제',
};

type Props = {
  uid: string;
  itemName: string;
  itemId?: string;
  type: ItemHistoryType;
  count: number;
  memo?: string;
};

export async function addItemHistory({
  uid,
  itemName,
  itemId,
  type,
  count,
  memo,
}: Props) {
  return await firestore
    .collection(CollectionPath.USERS)
    .doc(uid)
    .collection('itemHistory')
    .add({
      itemName: itemName || '',
      itemId: itemId || '',
      type,
      text: itemHistoryTypeMap[type] || type,
      count,
      memo: memo || '',
      createdAt: new Date(),
    });
}
